module.exports = __webpack_public_path__ + "img/muying.59f65915.png";